import { render, staticRenderFns } from "./ObloMap.vue?vue&type=template&id=4b261d90&scoped=true&"
import script from "./ObloMap.vue?vue&type=script&lang=js&"
export * from "./ObloMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b261d90",
  null
  
)

export default component.exports